import type { FaireProductEntity } from "../../entity_types/product";

export const p_2at42vw3cd: FaireProductEntity = {
  token: "p_2at42vw3cd",
  type: "product",
  name: "Hot Pink Checkered Huggies",
  brandToken: "b_7acb73exdq",
  brandName: "Pierced Co",
  imageUrl:
    "https://cdn.faire.com/fastly/ad8ad3cfe5dcf43f150bd023a975733733b4356233cff81effb1bb66725e2c7a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7b9e1f37ad0a521b188787df50cff73db1969709a53e122ccc42462ebfaea0c2.jpeg",
  ],
  priceDollars: 14,
  description:
    "\n\nHigh-quality earrings made for girls with sensitive ears and to join them on their everyday adventures. We are passionate about creating classic and fun designs inspired by the curiousness of childhood. Materials \n * Surgical grade stainless steel \n * 18K gold plated \n * Lead & nickel free \n * Always hypoallergenic \nDetails\n\n * 9mm clasp huggies \n * Water-resistant- can be worn in the pool and bath \nExclusive Pierced Co Extras\n\n * 100% guaranteed to be sensitive free or your order is free \n\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:45.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
